import React, { Component } from 'react';
import Header from './Header';
import VerifySuccess from './VerifySuccess';
import BadRequest from './BadRequest';
import InternalServerError from './InternalServerError';
import RequestExpired from './RequestExpired';
import SpinnerLoad from './SpinnerLoad';
import Footer from './Footer';
import axios from '../../node_modules/axios';
import CryptoJS from 'crypto-js';

class EmailVerify extends Component {

  constructor() {
    super();
    this.state = {
      verifySuccess: false,
      badRequest: false,
      internalServerError: false,
      requestExpired: false
    }
  }

  componentWillMount(){
    this.onDecryptReqID();
  }

  async onDecryptReqID(){
    var urlParams = new URLSearchParams(window.location.search);
    var requestId=urlParams.get('requestId').replace(/ /g,"+");
    console.log('Encrypted requestId ',requestId)
    let iterations = 128;
    let bytes = CryptoJS.PBKDF2(this.props.password, this.props.salt, { keySize: 48, iterations: iterations });
    let iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    let key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));
    var ciphertext = CryptoJS.enc.Base64.parse(requestId);
    var decrypted = CryptoJS.AES.decrypt({ciphertext: ciphertext}, key, {
      iv: iv
    });
    var CustomerReqId = decrypted.toString(CryptoJS.enc.Utf8)
    console.log('Decrypted requestId ',CustomerReqId)
    var Data = "requestId=" +CustomerReqId;
    var encryptedData = CryptoJS.AES.encrypt(Data, this.props.password).toString();
      
    var obj = { "url": process.env.REACT_APP_DPR_API_URL+
      '/EmailVerification?'+encryptedData,
                  "method":"GET"
                };
    try {
      const response = await axios({
        url: '/servercall/DPRAPI',
        method: 'POST',
        data: obj
      })

      let bytes = CryptoJS.AES.decrypt(response.data,this.props.password);
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      console.log('decryptRes ',decryptRes)
      if(decryptRes.status === 'REQUEST RECEIVED'){
        this.setState({verifySuccess:true});
      }
      else if(decryptRes.status === 'Missing request ID' || 
        decryptRes.status === 'Invalid request ID'){
        this.setState({badRequest:true});
      }
      else if(decryptRes.status === 'REQUEST EXPIRED'){
        this.setState({requestExpired:true});
      }
      else {
        this.setState({internalServerError:true});
      }
    } 
    catch(e) {
      console.log(e);
      this.setState({internalServerError:true});
      return e;
    } 
  }

  render() {
    return (
      <div className="app">
        <Header />
        {
          (this.state.verifySuccess ?
          <VerifySuccess/>
          : this.state.badRequest ? 
          <BadRequest/>
          : this.state.internalServerError ?
          <InternalServerError/> 
          : this.state.requestExpired ? 
          <RequestExpired/> : <SpinnerLoad/>)
        }
        <Footer />     
      </div>
    );
  }
}

export default EmailVerify;



// WEBPACK FOOTER //
// src/components/EmailVerify.js